// Simplified-Chinese strings for the admin area. Keys are the exact English source strings.
export const admin: Record<string, string> = {
  // Admin sign-in
  'Admin sign in': '管理员登录',
  'Sign in with an admin account to manage Pinpoint.': '使用管理员账户登录以管理 Pinpoint。',

  // AdminShell chrome + nav
  'Pinpoint Admin': 'Pinpoint 管理后台',
  'Platform admin': '平台管理',
  'Dashboard': '仪表盘',
  'Activity': '动态',
  'Tenants & People': '租户与用户',
  'Content': '内容',
  'Users': '用户',
  'Workspaces': '工作区',
  'Videos': '视频',
  'Sign out': '退出登录',

  // Dashboard / Overview
  'Overview': '概览',
  'Overview · Admin': '概览 · 管理后台',
  'Platform health across all workspaces.': '所有工作区的平台健康状况。',
  'Notes': '笔记',
  'Storage': '存储',
  'Needs attention': '需要关注',
  'All clear — no issues right now.': '一切正常 — 目前没有问题。',
  'Transcoding': '转码',
  'Ready': '就绪',
  'Uploaded': '已上传',
  'Uploading': '上传中',
  'Processing': '处理中',
  'Recent videos': '最近视频',
  'View all': '查看全部',
  'Source mix': '来源占比',
  'Upload': '上传',
  'Recent signups': '最近注册',
  'Suspended': '已停用',
  'Active': '正常',
  '{count} new · 30d': '{count} 新增 · 30天',

  // Users
  'Users · Admin': '用户 · 管理后台',
  'Search email…': '搜索邮箱…',
  'Search': '搜索',
  'Email': '邮箱',
  'Status': '状态',
  'Role': '角色',
  'Last active': '最近活跃',
  'Joined': '加入时间',
  'Joined {date}': '加入于 {date}',
  'No users match.': '没有匹配的用户。',
  'Admin': '管理员',
  'Revoke admin': '撤销管理员',
  'Make admin': '设为管理员',
  'Impersonate': '模拟登录',
  'Impersonate {email}? You will be signed in as them.': '模拟登录 {email}？你将以该用户身份登录。',
  'Suspend': '停用',
  'Suspend {email}? They will be signed out and blocked from signing in.': '停用 {email}？该用户将被登出并无法再登录。',
  'Reactivate': '恢复',
  'Send reset email': '发送重置邮件',
  'User ID': '用户 ID',

  // Videos
  'Videos · Admin': '视频 · 管理后台',
  'Title': '标题',
  'Source': '来源',
  'Workspace': '工作区',
  'Uploader': '上传者',
  'Transcode': '转码',
  'Duration': '时长',
  'Created': '创建时间',
  'Search title…': '搜索标题…',
  'All': '全部',
  'No videos match.': '没有匹配的视频。',
  'Video ID': '视频 ID',
  'VOD key': 'VOD 键',
  'VOD status': 'VOD 状态',

  // Workspaces
  'Workspaces · Admin': '工作区 · 管理后台',
  'Name': '名称',
  'Slug': '别名',
  'Owner': '所有者',
  'Members': '成员',
  'Search name or slug…': '搜索名称或别名…',
  'No workspaces match.': '没有匹配的工作区。',
  'Workspace ID': '工作区 ID',
  'owner': '所有者',
  'member': '成员',

  // Activity
  'Activity · Admin': '动态 · 管理后台',
  'Recorded changes across the platform.': '平台范围内记录的变更。',
  'Type': '类型',
  'No activity yet.': '暂无动态。',
  'system': '系统',
  'create': '创建',
  'update': '更新',
  'destroy': '删除',
}
